/**
 *
 * @type {function[]}
 */
const onScrollCallbacks = [];

$(window).on('scroll', function onScroll() {
    $.each(onScrollCallbacks, function each(index, callback) {
        $.isFunction(callback) && callback();
    });
});

/**
 *
 * @param {function|string} callback
 * @return {jQuery|boolean[]|boolean}
 */
$.fn.inViewport = function inViewport(callback) {
    /**
     *
     * @type {$}
     */
    const $elements = this;

    if ('getBoolean' === callback) {
        return resolve();
    }

    else {
        onScrollCallbacks.push(resolve);

        resolve();

        return $elements;
    }

    /**
     *
     * @return {boolean|boolean[]}
     */
    function resolve() {
        /**
         *
         * @type {boolean[]}
         */
        const isInViewportAry = [];

        $elements.each(function each(index, Element) {
            const $element = $(Element);
            const elementOffset = $element.offset();
            const elementHeight = $element.outerHeight();
            const elementWidth = $element.outerWidth();
            const rect = {
                bottom: elementOffset.top - pageYOffset + elementHeight,
                height: elementHeight,
                left: elementOffset.left,
                right: elementOffset.left + elementWidth,
                top: elementOffset.top - pageYOffset,
                width: elementWidth,
                x: elementOffset.left,
                y: elementOffset.top - pageYOffset
            };

            const isTopInView = rect.top >= 0 && rect.top <= innerHeight;
            const isBottomInView = rect.bottom >= 0 && rect.bottom <= innerHeight;

            const isTopOnTop = rect.top === 0;
            const isTopBeforeView = rect.top < 0;
            const isBottomAfterView = rect.bottom > innerHeight;
            const isBottomOnBottom = rect.bottom === innerHeight;

            const isInViewportY = (
                (isTopInView || isBottomInView) ||
                (isTopBeforeView && isBottomInView) ||
                (isBottomAfterView && isTopInView) ||
                (isTopBeforeView && isBottomAfterView)
            );

            const isInViewportX = (
                (rect.left >= 0 && rect.left <= innerWidth) ||
                (rect.right >= 0 && rect.right <= innerWidth)
            );

            const isInViewport = isInViewportX && isInViewportY;

            'function' === typeof callback && callback(Element, isInViewport, off, {
                isTopInView,
                isBottomInView,
                isTopBeforeView,
                isBottomAfterView,
                isTopOnTop,
                isBottomOnBottom
            });

            isInViewportAry.push(isInViewport);
        });

        return isInViewportAry.length > 1 ? isInViewportAry : isInViewportAry[0];
    }

    /**
     * toggle off observer
     */
    function off() {
        onScrollCallbacks.splice(
            onScrollCallbacks.indexOf(resolve),
            1
        );
    }
};



// WEBPACK FOOTER //
// ./js/main/plugin/in-viewport.js